<template>
  <div class="substep-get-team-set-up">
    <div class="substep-header">
      <h3 data-testId="step-title">Get your team set up</h3>
      <p>Invite your team to start tracking and unlock full visibility.</p>
    </div>
    <div class="substep-body">
      <div class="invite-column">
        <div class="invite-via-email-section">
          <h4 class="invite-section-title">Invite your team via email</h4>
          <InviteMembers
            :invites="invites"
            :organization="organization"
            hide-header
            hide-cancel-button
            send-button-text="Send invites"
            :max-invite-rows="1"
            invite-source="VSMB Getting Started"
            :reload-substep="reloadSubstep"
            :complete-substep="completeSubstep"
            class="substep-invite-members"
            @complete-substep="onInviteCompleted"
          />
        </div>
        <div class="invite-via-link-section">
          <h4 class="invite-section-title">Invite your team via link</h4>
          <VsmbInviteLinkCopy
            :value="inviteUrl"
            @copied="onInviteLinkCopied"
          />
          <p class="invite-via-link-helper">
            Or, invite your team by sending them this link.
          </p>
        </div>
      </div>
      <div class="resources-column">
        <div class="video-section">
          <div class="resources-column-title">Hubstaff quickstart guide for new users</div>
          <div class="resources-column-description">This video shows what your team will see.</div>
          <a
            :href="quickstartVideoUrl"
            class="video-section-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="VSMB_GETTING_STARTED_QUICKSTART_VIDEO_IMG"
              alt="Hubstaff quickstart guide for new users"
            />
          </a>
        </div>
        <div class="toolkit-section">
          <div class="resources-column-title">Get your team familiar with Hubstaff</div>
          <div class="resources-column-description">
            Check out the 👉
            <a
              :href="employeeEngagementToolkitUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hubstaff employee engagement toolkit
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InviteMembers from '~/components/growth_wizard/getting_started/substeps/InviteMembers.vue';
import VsmbInviteLinkCopy from '~/components/growth_wizard/getting_started/substeps/VsmbInviteLinkCopy.vue';
import { VSMB_GETTING_STARTED_QUICKSTART_VIDEO_IMG } from '~/rails_assets';

export default {
  name: 'GetTeamSetUp',
  components: {
    InviteMembers,
    VsmbInviteLinkCopy,
  },
  props: {
    invites: {
      type: Array,
      default: () => [],
    },
    organization: {
      type: Object,
      required: true,
    },
    inviteUrl: {
      type: String,
      default: '',
    },
    quickstartVideoUrl: {
      type: String,
      default: '',
    },
    employeeEngagementToolkitUrl: {
      type: String,
      default: '',
    },
    reloadSubstep: {
      type: Function,
      default: null,
    },
    completeSubstep: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    VSMB_GETTING_STARTED_QUICKSTART_VIDEO_IMG,
  }),
  methods: {
    async onInviteCompleted() {
      if (this.completeSubstep) {
        await this.completeSubstep();
      } else {
        this.$emit('completeSubstep');
      }
    },
    async onInviteLinkCopied() {
      window.analytics?.track('Member invited URL', { invite_via_link: true });
      await this.onInviteCompleted();
    },
  },
};
</script>
